module.exports = __webpack_public_path__ + "static/media/6-2.d5962fd8.mp3";